import React, { FC, useCallback, useEffect, useState } from "react";
import { Form, Input, Row, Col, Button, Select } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import DiagnosisSelectorModal from "../../../../utils/DiagnosisSelectorModal";

interface AilmentDetailsProps {
  isEditable: boolean;
  caseClaimSubmissionId: number | null;
  disabled?: any;
  form: any;
}

const { Option } = Select;

const AilmentDetails: FC<AilmentDetailsProps> = ({
  isEditable,
  caseClaimSubmissionId,
  disabled,
  form,
}) => {
  const diagnosisList = Form.useWatch(" diagnosisList", form) || [];
  const { patients } = useSelector((state: RootState) => state);

  const [diagnosisTypes] = useState([
    { label: "Final", value: "Final" },
    { label: "Relevant", value: "Relevant" },
    { label: "Others", value: "Others" },
  ]);

  const handleAddEntry = useCallback(() => {
    const currentList = form.getFieldValue("diagnosisList") || [];
    const updatedDiagnosis = currentList?.map((item: any, idx: any) => {
      return { ...item, diagnosisId: idx + 1 };
    });
    form.setFieldsValue({
      diagnosisList: [
        ...updatedDiagnosis,
        {
          diagnosisId: updatedDiagnosis.length + 1,
          diagnosisName: "",
          icdCode: "",
          typeOfDiagnosis: "Final",
        },
      ],
    });
  }, [form]);

  useEffect(() => {
    if (diagnosisList.length === 0 && !diagnosisList.length) {
      form.setFieldsValue({
        diagnosisList: [
          {
            diagnosisId: 1,
            diagnosisName: "",
            icdCode: "",
            typeOfDiagnosis: "Final",
          },
        ],
      });
    }
  }, []);

  const [modalVisible, setModalVisible] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState<number | null>(null);

  const handleOpenModal = (index: number) => {
    setActiveRowIndex(index);
    setModalVisible(true);
  };

  const handleModalSave = (diagnosis: string, icdCode: string) => {
    const current = form.getFieldValue("diagnosisList");
    const updated = [...current];
    updated[activeRowIndex!] = {
      ...updated[activeRowIndex!],
      diagnosisName: diagnosis,
      icdCode,
    };
    form.setFieldsValue({ diagnosisList: updated });
  };

  return (
    <>
      <h3>Ailment Details</h3>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item
            name="remarks"
            label="Hospital Remark"
            rules={[
              {
                required: true,
                message: "Please input hospital remarks",
              },
            ]}
          >
            <Input disabled={!isEditable} />
          </Form.Item>
        </Col>

        {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
        "OP" ? (
          <></>
        ) : (
          <Col span={8}>
            <Form.Item name="treatingDoctorName" label="Treating Doctor">
              <Input disabled={!isEditable} />
            </Form.Item>
          </Col>
        )}
        <Col span={8}>
          <Form.Item
            name="natureOfAilment"
            label="Nature Of Ailment"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input disabled={!isEditable} />
          </Form.Item>
        </Col>
      </Row>

      {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
      "OP" ? (
        <div className="provisional-diagnosis-section">
          <h3>PROVISIONAL DIAGNOSIS</h3>
          <Form.List name="diagnosisList">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <Row key={key} gutter={[24, 0]} className="form-row">
                    <Col span={3}>
                      <Form.Item
                        {...restField}
                        name={[name, "typeOfDiagnosis"]}
                        // rules={[{ required: true, message: "*" }]}
                      >
                        <Select
                          placeholder="Select Diagnosis Type"
                          disabled={disabled}
                          allowClear
                        >
                          {diagnosisTypes?.map((item) => (
                            <Option key={item.value} value={item.value}>
                              {item.label}
                            </Option>
                          ))}
                        </Select>
                        {/* <Input
                                              placeholder="Enter Diagnosis"
                                              disabled={disabled}
                                            /> */}
                      </Form.Item>
                    </Col>
                    <Col span={13}>
                      <Form.Item
                        {...restField}
                        name={[name, "diagnosisName"]}
                        // rules={[{ required: true, message: "*" }]}
                      >
                        <Input
                          placeholder="Enter Diagnosis"
                          // disabled={true}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Form.Item
                        {...restField}
                        name={[name, "icdCode"]}
                        // rules={[{ required: true, message: "*" }]}
                      >
                        <Input
                          placeholder="Enter ICD Code"
                          // disabled={true}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      <Button
                        type="primary"
                        onClick={() => handleOpenModal(index)}
                        disabled={disabled}
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                        }}
                      >
                        Add Diagnosis
                      </Button>
                    </Col>
                    {disabled ? (
                      <></>
                    ) : (
                      <Col span={2}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Col>
                    )}
                  </Row>
                ))}
                {disabled ? (
                  <></>
                ) : (
                  <Form.Item>
                    <Button
                      type="dashed"
                      // onClick={() => add()}
                      onClick={() => {
                        // add();
                        handleAddEntry();
                      }}
                      block
                      icon={<PlusOutlined />}
                      disabled={disabled}
                    >
                      Add Provisional Diagnosis
                    </Button>
                  </Form.Item>
                )}
              </>
            )}
          </Form.List>
        </div>
      ) : (
        <></>
      )}

      <DiagnosisSelectorModal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onSave={handleModalSave}
        hospitalId={patients?.fetchBasicDetails?.casesResponse?.healthCareId}
        schemeId={patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId}
      />
    </>
  );
};

export default AilmentDetails;
